/*
 * ErrorBoundary messages
 *
 * This contains all the text for the ErrorBoundary component
 */

import { defineMessages } from 'react-intl';

export default defineMessages({
  headline: {
    id: 'components.ErrorBoundary.headline',
    defaultMessage: 'Oops, something went wrong here',
  },
  message: {
    id: 'components.ErrorBoundary.message',
    defaultMessage:
      'We encountered a problem while loading this page. You might need to restart from the {homepageCta}. Please contact our support team if this issue persists.',
  },
  homepageCta: {
    id: 'components.ErrorBoundary.homepageCta',
    defaultMessage: 'homepage',
  },
});
